import { textPropsSchema } from '../component-catalog.js';
export const textDefinition = {
    type: 'Text',
    category: 'content',
    propsSchema: textPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Inline text block. Props: text (required), variant? ("h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "body" | "caption").',
};
//# sourceMappingURL=Text.js.map